module.exports = __webpack_public_path__ + "img/18.ab03ce9f.png";